export default __webpack_public_path__ + "static/comparisons-app-creation-dced37cba2dde55722c76c047c340c15.png";